// this is here because https://github.com/webpack/webpack/issues/300 prevents
// us from being able to import from index.js. TODO: refactor index.js to use
// showGallery without breaking hot-reload.
import { Gallery } from './Gallery'
import React from 'react'
import ReactDOM from 'react-dom'
import { BrowserRouter as Router } from 'react-router-dom'
import StandaloneLocaleProvider from 'bundles/core/StandaloneLocaleProvider'

export const showGallery = (props) => {
  const domNode = getDomNode()
  ReactDOM.render(
    <StandaloneLocaleProvider>
      <Router>
        <Gallery {...props} onRequestClose={unmount} />
      </Router>
    </StandaloneLocaleProvider>,
    domNode
  )
}

const getDomNode = () => {
  const node = document.getElementById('react-gallery')
  if (node) {
    return node
  }
  const div = document.createElement('div')
  div.id = 'react-gallery'
  document.body.appendChild(div)
  return div
}

const unmount = () => {
  const node = getDomNode()
  ReactDOM.unmountComponentAtNode(node)
}
